import type { ContainerConfig } from '../../components/container-types/types';

const isSecondaryTypeDrawer = (
  containerConfig?: ContainerConfig,
) => {
  let result = false;

  if (
    containerConfig?.type === 'inline' &&
    containerConfig?.secondaryContainer?.type === 'drawer'
  ) {
    result = true;
  }

  return result;
};

export default isSecondaryTypeDrawer;
